export default __webpack_public_path__ + "static/assets/9d72f82fa6dbcfca230a68ba55d1fe96.jpg";